import { QueryClientProvider } from '@tanstack/react-query'

import { getQueryClient } from '@/modules/Infrastructure'

import { ProductInfoSections } from './ProductInfo/ProductInfoSections'
import { CheckoutProvider } from '../../../Checkout'
import { UiProvider } from '../../../Theme'
import { WishlistProvider } from '../../../Wishlist'
import { getProductViewConfig } from '../../lib/productViewConfig'
import { ProductAttributeProvider } from '../../state'

const queryClient = getQueryClient()

export function ProductInfo() {
  const { productSku } = getProductViewConfig()

  return (
    <QueryClientProvider client={queryClient}>
      <UiProvider>
        <CheckoutProvider>
          <WishlistProvider>
            <ProductAttributeProvider productSku={productSku}>
              <ProductInfoSections sku={productSku} />
            </ProductAttributeProvider>
          </WishlistProvider>
        </CheckoutProvider>
      </UiProvider>
    </QueryClientProvider>
  )
}
